import { lazy } from 'react';

const tuneSVG = './assets/icons/tune.svg';

const EntryPoint = lazy(() => import('./components/EntryPoint/EntryPoint'));
const DeviceCommandsLoader = lazy(() => import('./components/DeviceCommandsLoader/DeviceCommandsLoader.container'));

export const defaultPath = '/deviceCommands';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: DeviceCommandsLoader,
        exact: true,
        icon: tuneSVG,
        title: { key: '', plural: false },
        subTitle: { key: '', plural: false },
    }
];

// El acceso lo controla hasRouteAccess via ADMIN_ONLY_ROUTES: este modulo solo
// lo ve el perfil admin, tanto en el sidebar como al entrar por url.
const DeviceCommands = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: tuneSVG,
    title: { key: 'Comandos a equipos', plural: false },
    subTitle: { key: 'Envío de comandos a uno o varios IMEIs', plural: false },
    innerRoutes,
    pathChilds: innerRoutes.map(r => r.path),
};

export default DeviceCommands;
